/** 
 * CARD-CONTAINER
 * Container for card-button
 */

interface OwnProps{
  children : any,
  isAlignedLeft? : boolean,
  displayMode?: "grid" | "list"
}

function CardContainer(props:OwnProps) {
  return (
    <div className={`card-container flex ${props.displayMode === "list" ? "flex-col gap-[12px]" : "flex-wrap"}`}
      style={{ 
        justifyContent: !props.isAlignedLeft ? "center" : "",
        marginLeft: props.displayMode === "list" ? 0 : undefined
      }}>
      { props.children}
    </div>
  )
}

export default CardContainer
